export default "__VITE_ASSET__DZh$UkzL__"